import {
  Button,
  Card,
  Col,
  Input,
  Pagination,
  Row,
  Spin,
  Table,
  Select,
  message,
  Popconfirm
} from "antd";
import { LoadingOutlined,DownloadOutlined,DeleteOutlined } from "@ant-design/icons";
import debounce from 'lodash.debounce';
import React, { useEffect, useState, useCallback } from "react";
import { EXPORT_DOWNLOAD_REPORT, LIST_CAMPAIGN_REPORT,DELETE_CAMPAIGN_OFFENDER_REPORT } from "../../../apis/apis";
import CulsightPageLoader from "../../../components/CulsightPageLoader";
import { formatToIST } from "../../../../helper/CommonHelper";


function CampaignDownload() {


  const [loader, setLoader] = useState(true);
  const [search_query_name, set_search_query_name] = useState("");

  const [pagination_loader, set_pagination_loader] = useState(false);
  const [table_data, set_table_data] = useState([]);
  const [current_page, set_current_page] = useState(1);
  const [total_pages, set_total_pages] = useState(0);


  const [page_size, set_page_size] = useState(10);
  const [total_items, set_total_items] = useState(0);


  const LIST_API = async (page = 1, per_page = page_size) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("page", page);
    FORM_DATA.append("per_page", per_page);

    const API_CALL = await LIST_CAMPAIGN_REPORT(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);

      set_total_items(API_CALL?.data?.total_items ?? (API_CALL?.data?.total_pages ? API_CALL?.data?.total_pages * per_page : 0)); // ⭐ CHANGE (fallback)
      set_total_pages(API_CALL?.data?.total_pages ?? 0);
      setLoader(false);
    } else {
      console.log("error");
      setLoader(false);
    }
  };


  // SEARCH API
  const fetchResultsName = useCallback(
    debounce(async (value) => {
      try {
        set_search_query_name(value);
        set_pagination_loader(true);

        const FORM_DATA = new FormData();
        FORM_DATA.append("name", value);
        FORM_DATA.append("page", 1);
        FORM_DATA.append("per_page", page_size);

        const API_CALL = await LIST_CAMPAIGN_REPORT(FORM_DATA);

        if (API_CALL?.data?.status) {
          set_table_data(API_CALL.data?.data);
          set_current_page(API_CALL?.data?.current_page);
          set_total_pages(API_CALL?.data?.total_pages);
          set_total_items(API_CALL?.data?.total_rows);
        }

        set_pagination_loader(false);
      } catch (err) {
        console.error("API Error:", err);
      }
    }, 500),
    []
  );


  //for soft delete


const DELETE_CAMPAIGN_REPORT = async (id) => {
  const FORM_DATA = new FormData();
  FORM_DATA.append("id", id);

  try {
    const response = await DELETE_CAMPAIGN_OFFENDER_REPORT(FORM_DATA);
    if (response?.data?.status) {
      message.success("Campaign deleted successfully");
      LIST_API(); // refresh table
    } else {
      message.error("Failed to delete campaign");
    }
  } catch (err) {
    message.error("Something went wrong");
  }
};



  const handleInput = (e) => {
    const value = e.target.value;
    fetchResultsName(value);
  };


  const EXPORT_DOWNLOAD_REPORT_ACTION = async (id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("id", id);
    const API_CALL = await EXPORT_DOWNLOAD_REPORT(FORM_DATA);
    if (API_CALL?.data?.status) {
      window.location = API_CALL?.data?.url
    } else {
      console.log("error");
      setLoader(false);
    }
  };

  useEffect(() => {
    LIST_API();
  }, []);

  const columns = [
    {
      title: "Created Date",
      render: (text, record) => (
        <span>{formatToIST(record.created_at)}</span>
      ),
    },

    {
      title: "Name",
      dataIndex: "report_view",
      render: (text, record) => {
        try {
          const match = record.report_view.match(/'name':\s*'([^']+)'/);
          return <span>{match ? match[1] : "N/A"}</span>;
        } catch (e) {
          return <span>N/A</span>;
        }
      },
    },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <>
        <Button onClick={() => EXPORT_DOWNLOAD_REPORT_ACTION(record?.id)} variant="solid"  size="small" style={{marginRight:"12px",backgroundColor: "#1fa7a1", color: "#ffffff"}}>
         <DownloadOutlined/>
        </Button>
        

        <Popconfirm
  title="Are you sure you want to delete this report?"
  okText="Yes"
  cancelText="No"
  onConfirm={() => DELETE_CAMPAIGN_REPORT(record?.id)}
>
  <Button
    variant="solid"
    color="danger"
    size="small"
  >
    <DeleteOutlined />
  </Button>
</Popconfirm>
        </>

      ),
    },
  ];


  const pagination_on_change = async (data) => {
    set_pagination_loader(true);
    set_current_page(data);
    await LIST_API(data, page_size);
    set_pagination_loader(false);
  };


  const handlePageSizeChange = (value) => {
    set_page_size(value);
    set_current_page(1);
    setLoader(true);
    LIST_API(1, value).then(() => setLoader(false));
  };

  return (
    <div>

      

        <Col span={20}>
          <Input
            addonBefore={<span>Name</span>}
            placeholder="Search by name"
            onChange={handleInput}
            size="large"
          />
        </Col>
        {loader ? (
          <CulsightPageLoader />
        ) : (
          <>
            {pagination_loader ? (
              <div style={{ textAlign: "center", padding: "60px" }}>
                <Spin indicator={<LoadingOutlined spin />} size="large" />
              </div>
            ) : (
              <Table
                columns={columns}
                pagination={false}
                dataSource={table_data}
                style={{ marginTop: "15px" }}
                rowKey="id"
              />
            )}

            {total_items > 0 ? (
              <div style={{ display: "flex", justifyContent: "flex-end", gap: "15px", marginTop: "20px" }}>

                <Pagination
                  onChange={pagination_on_change}
                  current={current_page}
                  total={total_items}
                  pageSize={page_size}
                  showSizeChanger={false}
                />


                <Select
                  value={page_size}
                  onChange={handlePageSizeChange}
                  style={{ width: 120 }}
                  options={[
                    { value: 10, label: "10 / page" },
                    { value: 20, label: "20 / page" },
                    { value: 50, label: "50 / page" },
                    { value: 100, label: "100 / page" },
                  ]}
                />

              </div>
            ) : (
              <div style={{ textAlign: "center", color: "red" }}>
                {/* <h2>No Data Found</h2> */}
              </div>
            )}

          </>
        )}
     
    </div>
  );

}

export default CampaignDownload;
